// removed by extract-text-webpack-plugin
module.exports = {"secondaryHeaderBar":"_3wkZVQiMrLtABI3cq4hHxl","headerText":"_1jRMEqpMKouhdmQxLcrSv6","btn":"ZzqP-1NKu4vCn_hJBCAzG","requestRefillsBtn":"_1c0zu2Zd36BAZukSM95DzJ","requestRefillIcon":"_3Mj0Nox1Nr5XAEqlMHwd3D","requestRefillText":"_2Q4b52OCwGb6ImiUCF6cJV","btnLoadingContainer":"_2ZDxwsQG7cry_htXs4UNIZ","bodyLoadingContainer":"_3tiD3rVdusvrS5P07ORjxA","MedicationsLandingPageBackButtonContainer":"_3KvqkOcGqBaCMyflRL81NI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/MedicationsLandingPage/MedicationsLandingPage.css
// module id = 1285
// module chunks = 0